import smartSolveApi from './instances/smartsolve';

export const getAllUINotifications = async () => {
  try {
    const response = await smartSolveApi.post('/getAllUINotifications', {});

    if (response) {
      return response.data;
    }
    return;
  } catch (e) {
    throw new Error(`getAllUINotifications'() failed: ${e}`);
  }
};

export const setUINotificationUserAction = async (notificationActions) => {
  try {
    const response = await smartSolveApi.post('/SetUINotificationUserAction', notificationActions);
    return response.data;
  } catch (e) {
    throw new Error(`setUINotificationUserAction'() failed: ${e}`);
  }
};

export const getNewUINotifications = async (datetime) => {
  try {
    const response = await smartSolveApi.post('/GetNewUINotifications', datetime, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (e) {
    throw new Error(`getNewUINotifications'() failed: ${e}`);
  }
};
